import { appApi } from '../app_api';

export const eventResultsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getEventResults: builder.query({
      query: (eventId) => `/events/${eventId}/event_player_results`,
      transformResponse: (response) => response.data || [],
      providesTags: (result, error, eventId) => 
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Result', id })),
              { type: 'EventResults', id: eventId },
            ]
          : [{ type: 'EventResults', id: eventId }],
    }),
    getEventResultsByDivision: builder.query({
      query: (eventId) => `/events/${eventId}/event_player_results/by_division`,
      transformResponse: (response) => response.data || [],
      providesTags: (result, error, eventId) => [{
        type: 'EventResultsByDivision', id: eventId
      }],
    }),
    editEventResult: builder.mutation({
      query: ({ eventId, resultId, pointsEarned, place }) => {
        return ({
        url: `/events/${eventId}/event_player_results/${resultId}`,
        method: 'PUT',
        body: { pointsEarned: pointsEarned, place: place },
      })},
      invalidatesTags: (result, error, { eventId, resultId }) => [
        { type: 'Result', id: resultId },
        { type: 'EventResults', id: eventId },
        { type: 'EventResultsByDivision', id: eventId },
      ],
    }),
    getLeagueTieMatches: builder.query({
      query: ({ eventId, playerIds }) =>
        `/events/${eventId}/event_player_results/tie_matches?${playerIds.map(id => `player_ids[]=${id}`).join('&')}`,
      transformResponse: (response) => response,
    }),
    resolveLeagueTies: builder.mutation({
      query: ({ eventId, resolvedGroups }) => ({
        url: `/events/${eventId}/event_player_results/resolve_ties`,
        method: 'PUT',
        body: { resolvedGroups },
      }),
      invalidatesTags: (result, error, { eventId }) => [
        { type: 'EventResultsByDivision', id: eventId },
      ],
    }),
    changeResultDivisionStatus: builder.mutation({
      query: ({ eventId, resultId, divisionStatus }) => ({
        url: `/events/${eventId}/event_player_results/${resultId}`,
        method: 'PUT',
        body: { divisionStatus },
      }),
      invalidatesTags: (result, error, { eventId }) => [
        { type: 'EventResultsByDivision', id: eventId },
      ],
    }),
    confirmResults: builder.mutation({
      query: (eventId) => ({
        url: `/events/${eventId}/confirm_results`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, eventId) => [
        { type: 'EventResults', id: eventId },
        { type: 'EventResultsByDivision', id: eventId },
        { type: 'Event', id: eventId },
      ],
    }),
    sendDemoFeedback: builder.mutation({
      query: (message) => ({
        url: `/events/demo_feedback`,
        method: 'POST',
        body: { message },
      }),
    }),
  }),
});

export const {
  useGetEventResultsQuery,
  useGetEventResultsByDivisionQuery,
  useGetLeagueTieMatchesQuery,
  useEditEventResultMutation,
  useChangeResultDivisionStatusMutation,
  useConfirmResultsMutation,
  useResolveLeagueTiesMutation,
  useSendDemoFeedbackMutation,
} = eventResultsApi;